<template>
  <div class="h-100">
    <v-snackbar
      class="mt-5"
      :color='color'
      :timeout="3000"
      :top="true"
      v-model="alert"
    >{{message}}</v-snackbar>
    <div class="h-100 d-flex justify-center">
      <div id='check' class="bannerElement">
        <v-container fluid class="custom_fullScreen mb-auto">
          <v-layout row>
            <v-flex xs6 offset-xs3>
              <v-card class="container mb-auto border-all-1 corner-all-10 box_s">
                <div class="mb10">
                  <a class="link text-primary-apiculus" href="/">
                  <v-icon class="text-primary-apiculus">keyboard_arrow_left</v-icon>
                  <span class="icon_set">Back</span>
                  </a>
                </div>
              <img :src="navLogo" width="30%" class="mb32">
                <h3 class=""> Forgot Password? </h3>
                <div class="p10">
                  <v-text-field
                    label="*Enter your email"
                    v-model="form.email"
                    v-validate="'required|email'"
                    data-vv-name="email"
                    :error-messages="errors.collect('email')"
                    data-vv-validate-on="input|blur|update|change"
                  ></v-text-field>

                  <vue-recaptcha class="p10"
                    ref="recaptcha"
                    @verify="onCaptchaVerified"
                    @expired="onCaptchaExpired"
                    :sitekey="siteKey">
                  </vue-recaptcha>

                </div>
                <v-card-actions class="pl0">
                  <v-btn :disabled="!(fields.email && fields.email.valid && form['g-recaptcha-response'])" class="rounded-0" @click="sendVerificationLink">SEND LINK</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'ForgotPassword',
  data: () => ({
    form: {
      'g-recaptcha-response': '',
      email: ''
    },
    color: '',
    full_screen: '',
    message: '',
    navLogo: '',
    bannerAsset: '',
    bannerElement: false,
    alert: false
  }),
  computed: {
    siteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    }
  },
  components: { VueRecaptcha },
  methods: {
    sendVerificationLink () {
      this.$store.dispatch('ACTION_SEND_VERIFICATION_LINK', { ...this.form }).then(res => {
        if (!res.success) {
          this.color = 'error'
          this.message = res.error.message || 'Something went wrong, Please try again later.'
          this.alert = true
          this.form['g-recaptcha-response'] = ''
          this.$refs.recaptcha.reset()
        } else {
          this.$store.state.forEmailVerification = true
          this.$store.state.forAdminApproval = false
          this.$router.push('success')
        }
      })
    },
    onCaptchaVerified (res) {
      this.form['g-recaptcha-response'] = res
    },
    onCaptchaExpired (res) {
      this.form['g-recaptcha-response'] = ''
      this.$refs.recaptcha.reset()
    }
  },
  created () {
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'banner.png' }).then(res => {
      let downloadFiles
      if (res && typeof res === 'string') {
        downloadFiles = 'data:image/png;base64,' + res
        this.bannerAsset = downloadFiles
        this.bannerShow = true
        let urlString = ''
        setTimeout(() => {
          urlString = document.getElementById('check')
          urlString.classList.add('bannerElement')
          urlString.style.backgroundImage = 'url(' + this.bannerAsset + ')'
        }, 0)
      } else {
        this.bannerAsset = ''
        this.bannerShow = false
      }
    })
    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'logo.png' }).then(res => {
      if (res) {
        let downloadFile = 'data:image/png;base64,' + res
        this.navLogo = downloadFile
      } else {
        this.navLogo = ''
      }
    })
  }
}
</script>

<style lang="scss">
 .bannerElement {
     background-position: center center;
    background-repeat: no-repeat;
    // background-attachment: fixed;
    background-size: cover;
    // position: relative;
    display: flex;
    justify-content: center;
  }

  .container{
    width: 100%;
    margin-bottom: 90%;
  }
</style>
